import script from "./BlackMask.vue?vue&type=script&lang=ts&setup=true"
export * from "./BlackMask.vue?vue&type=script&lang=ts&setup=true"

import "./BlackMask.vue?vue&type=style&index=0&id=6483d52e&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6483d52e"]])

export default __exports__